import React from "react";
import { View, StyleSheet, type StyleProp, type ViewStyle, type DimensionValue } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { MotiView } from "moti";
import { colors, radii } from "../../../styles/design-system";

export interface SkeletonProps {
  width?: DimensionValue;
  height?: DimensionValue;
  borderRadius?: number;
  style?: StyleProp<ViewStyle>;
  variant?: "neutral" | "colorful";
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = "100%",
  height = 20,
  borderRadius = radii.md,
  style,
  variant = "neutral",
}) => {
  const dynamicStyle: ViewStyle = {
    width,
    height,
    borderRadius,
  };

  return (
    <View style={[styles.container, dynamicStyle, style]}>
      {variant === "colorful" ? (
        <>
          <LinearGradient
            colors={["#EEF2FF", "#FAE8FF", "#ECFDF3"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={StyleSheet.absoluteFill}
          />
          <MotiView
            from={{ translateX: -320 }}
            animate={{ translateX: 320 }}
            transition={{
              type: "timing",
              duration: 1300,
              loop: true,
            }}
            style={styles.colorfulShimmerWrap}>
            <LinearGradient
              colors={["transparent", "rgba(62, 104, 254, 0.35)", "rgba(210, 71, 255, 0.28)", "transparent"]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              style={StyleSheet.absoluteFill}
            />
          </MotiView>
        </>
      ) : (
        <MotiView
          from={{ translateX: -300 }}
          animate={{ translateX: 300 }}
          transition={{
            type: "timing",
            duration: 1500,
            loop: true,
          }}
          style={styles.shimmerOverlay}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.grey[100],
    overflow: "hidden",
    position: "relative",
  },
  shimmerOverlay: {
    position: "absolute",
    top: 0,
    left: "-50%",
    width: "50%",
    height: "100%",
    backgroundColor: colors.white,
    opacity: 0.6,
    // @ts-expect-error - works for web
    background: `linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent)`,
  },
  colorfulShimmerWrap: {
    position: "absolute",
    top: 0,
    left: "-50%",
    width: "55%",
    height: "100%",
    opacity: 0.9,
  },
});

export default Skeleton;
